import { render, staticRenderFns } from "./queries.vue?vue&type=template&id=7ecfa631&scoped=true"
import script from "./queries.vue?vue&type=script&lang=js"
export * from "./queries.vue?vue&type=script&lang=js"
import style0 from "./queries.vue?vue&type=style&index=0&id=7ecfa631&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecfa631",
  null
  
)

export default component.exports